var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-wrapper" } }, [
    _c(
      "ul",
      {
        staticClass: "sidebar-nav nav-pills nav-stacked",
        attrs: { id: "menu" }
      },
      [
        _c(
          "li",
          { attrs: { id: "homeLink" } },
          [
            _c(
              "router-link",
              { attrs: { to: { path: "/closeticket" }, href: "#" } },
              [
                _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                  _c("i", { staticClass: "fa fa-home fa-stack-1x" })
                ]),
                _vm._v("Home\n        ")
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.$store.getters.role == 1 || _vm.$store.getters.role == 2
          ? [
              _c("li", { attrs: { id: "reportLink" } }, [
                _vm._m(0),
                _vm._v(" "),
                _c("ul", { staticClass: "nav nav-list tree" }, [
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "HourlyReport" } } },
                        [_vm._v("Hourly Report")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "ListTicket" } } },
                        [_vm._v("All Tickets")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "FilteredListTicket" } } },
                        [_vm._v("Store wait times")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "TicketPerDay" } } },
                        [_vm._v("User Tickets")]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.$store.getters.role == 1 || _vm.$store.getters.role == 2
                ? [
                    _c(
                      "li",
                      { attrs: { id: "locationLink" } },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { path: "/location" }, href: "#" } },
                          [
                            _c(
                              "span",
                              { staticClass: "fa-stack fa-lg pull-left" },
                              [
                                _c("i", {
                                  staticClass: "fa fa-map-marker fa-stack-1x"
                                })
                              ]
                            ),
                            _vm._v("Location\n            ")
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { attrs: { id: "stationLink" } }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("ul", { staticClass: "nav nav-list tree" }, [
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: { name: "ListStationLocation" } }
                              },
                              [_vm._v("List Location Stations")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "ListStations" } } },
                              [_vm._v("List Stations")]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.role == 1
          ? [
              _c(
                "li",
                { attrs: { id: "userLink" } },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "/listuserlocation" }, href: "#" } },
                    [
                      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                        _c("i", { staticClass: "fa fa-user fa-stack-1x" })
                      ]),
                      _vm._v("Users\n        ")
                    ]
                  )
                ],
                1
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.role == 1 ||
        _vm.$store.getters.role == 2 ||
        _vm.$store.getters.role == 4
          ? [
              _c(
                "li",
                { attrs: { id: "tvScreenLink" } },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: "/tvscreen" }, href: "#" } },
                    [
                      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
                        _c("i", {
                          staticClass: "fa fa-film fa-stack-1x",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]),
                      _vm._v("TV Screen\n          ")
                    ]
                  )
                ],
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-bell fa-stack-1x" })
      ]),
      _vm._v("Reports "),
      _c("i", {
        staticClass: "arrow-handle fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "tree-toggle nav-header" }, [
      _c("span", { staticClass: "fa-stack fa-lg pull-left" }, [
        _c("i", { staticClass: "fa fa-location-arrow fa-stack-1x" })
      ]),
      _vm._v("Stations "),
      _c("i", {
        staticClass: "arrow-handle fa fa-angle-down",
        attrs: { "aria-hidden": "true" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d622f5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d622f5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = null
// module chunks = 